import { ScreenProps, SupportedComponent } from '@components-common/types';
import React from 'react';

export const RootieScreen: React.FC<any> = (props: ScreenProps<any>) => {
  const { view: component, ...rest } = props;
    return <RootieComponent component={component} />;
};

const SupportedComponentSwitch = ({ component }:{component:SupportedComponent}) => {
  if (React.isValidElement(component)) {
    return component;
  }

  if (typeof component === 'function') {
    return React.createElement(component);
  }

  if ('Component' in component) {
    const { Component, props } = component;
    return <Component {...props} />;
  }

  if ('cat' in component) {
    const { Component, props } = component;
    return <Component {...props} />;
  }

  return null;
};

export const RenderChildren: React.FC<any> = (props:any) => {
  const { children = [] } = props;
  return (
    <>
      {(children as any).map((child:any, index: number) => (
        <SupportedComponentSwitch key={child.key || child.id || index.toString()} component={child} />
      ))}
    </>
  );
};

export const RootieComponent: React.FC<any> = ({ component }) => {
  const { children=[] } = component;
  return (
 <div style={{height: '100%'}}>
      <SupportedComponentSwitch component={component} />
      {children && children.length > 0 && <RenderChildren children={children} />}
    </div>
  );
};
